import { useContext } from 'react';
import { ThemeContext } from '@/shared/lib/theme/themeContextValue';

export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme deve ser usado dentro de ThemeProvider');
  return ctx;
}
